export function bannersWithLinkSlider() {
    const $window = $(window);
    const $slider = $(".banners-with-link.slider-on-mobile");
    $slider.each(function () {
        let $this = $(this);
        $window.on("load resize", function () {
            if ($window.innerWidth() >= 768) {
                if ($this.hasClass("slick-initialized")) {
                    $this.slick('refresh');
                    $this.slick('unslick');
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        slidesToScroll: 1,
                        slidesToShow: 1.12,
                        infinite: false,
                        arrows: false,
                        dots: false,
                        mobileFirst: true,
                    });
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/bannersWithLinkSlider.js